import axios from 'axios';

const token = window.localStorage.getItem('@token')

const config = {
  'authorization': token ? `Baerer ${token}` : ""
};

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: config,
});